import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = { class: "flex w-[800px] flex-col gap-3 sm:gap-4" }


import LegalTitle from '@/components/Legal/LegalTitle.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LegalSection',
  props: {
  title: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LegalTitle, {
        title: props.title
      }, null, 8, ["title"]),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})